import { createFileRoute } from '@tanstack/react-router';
import { useActiveRealmAPIContext } from '@interxfi/api-client/realm-context';
import { DEFAULT_PAGE_LAYOUT_MAX_WIDTH_CONTAINER_SIZE, PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../components/router/router-tabbed-navigation';
import { HoursExceptionCreateDrawer } from '../../../../../../../features/hours/exception/hours-exception-create-drawer';
import { HoursExceptionsTable } from '../../../../../../../features/hours/exception/hours-exceptions-table';
import { getPageHead } from '../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/hours/_hours/exception/_exception/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.Hours,
      label: 'Exceptions',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.Hours>,
  head: () => getPageHead('Hours Exceptions'),
  component: HoursExceptionList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const { activeTenantIsClearing } = useActiveRealmAPIContext();

  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {activeTenantIsClearing ? (
            <RequiresAccess write>
              <HoursExceptionCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Exception" size="small" />} />
            </RequiresAccess>
          ) : null}

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.Hours}
    />
  );
}

function HoursExceptionList() {
  return (
    <PageLayout maxWidthContainer={DEFAULT_PAGE_LAYOUT_MAX_WIDTH_CONTAINER_SIZE}>
      <PageLayout.Section noBorder>
        <HoursExceptionsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
